if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
        setTimeout(() => {
          
        document.querySelectorAll(".show-more-item").forEach(function (item) {
          item.classList.add("hidden");
          console.log("item",item);
           const showMoreButton = document.querySelector(".button-show-more");
          const labelShowMore = showMoreButton.querySelector(".label-show-more");
          const labelShowLess = showMoreButton.querySelector(".label-show-less");

            labelShowMore.classList.remove("hidden");
            labelShowLess.classList.add("hidden");
        });
        }, 500);

      }
      expandShowMore(event) {
        const showMoreButton = document.querySelector(".button-show-more");
        const showMoreItems = document.querySelectorAll(".show-more-item");
        const labelShowMore = showMoreButton.querySelector(".label-show-more");
        const labelShowLess = showMoreButton.querySelector(".label-show-less");

          const isExpanded = labelShowMore.classList.contains("hidden");

          console.log("isExpanded", isExpanded);

          showMoreItems.forEach(function (item) {
            item.classList.toggle("hidden");
          });

          labelShowMore.classList.toggle("hidden");
          labelShowLess.classList.toggle("hidden");
      }
    }
  );
}
